import styles from "./LeavePolicy.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FiInfo } from "react-icons/fi";

const data = [
  {
    _id: "1",
    leaveType: "Medical",
    totalLeave: 7,
    monthlyIncrement: 0.58,
    defaultLeave: 7,
    halfDayLeave: "No",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "2",
    leaveType: "Medical",
    totalLeave: 7,
    monthlyIncrement: 0.58,
    defaultLeave: 7,
    halfDayLeave: "No",
    actions: ["Edit", "Delete"],
  },
  // Add more rows as needed
];
  

function LeavePolicy() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);

      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        leaveType: item.leaveType,
        totalLeave: item.totalLeave,
        monthlyIncrement: item.monthlyIncrement,
        defaultLeave: item.defaultLeave,
        halfDayLeave: item.halfDayLeave,
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => {
              if (opt === "Edit") dispatch(openModal("editItem"));
              if (opt === "Delete") dispatch(openModal("deleteItem"));
            }}
          />
        ),
      };
    });
  };
  

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Leave Type", accessor: "leaveType" },
    { title: "Total Leave", accessor: "totalLeave" },
    { title: "Monthly Increment", accessor: "monthlyIncrement" },
    { title: "Default Leave", accessor: "defaultLeave" },
    { title: "Half Day Leave", accessor: "halfDayLeave" },
    { title: "Actions", accessor: "action" },
  ];
  

  return (
    <div className={styles.headerContainer}>
      <div className={styles.infoLine}>
        <FiInfo className={styles.infoIcon} />
        <span>
          This leaves will be applied for the entire session year (01/01/2025 -
          01/01/2025)
        </span>
      </div>
      <div className={styles.totalstudentcard}>
        <div className={styles.roleAndNegativeWrapper}>
          <Dropdown label="All Roles" options={["Admin", "Staff"]} />
          <div className={styles.negativeLeaveWrapper}>
            <input type="checkbox" id="allowNegativeLeave" />
            <span htmlFor="allowNegativeLeave">
              Allow negative leave balance
            </span>
          </div>
        </div>

        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default LeavePolicy;
